export default function(http) {
  return {
      queryByPage(data){
          return http.json({
              url: `/system/sysRepairPersonnel/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
              data
          });
      },
      save(data){
          return http.json({
              url: '/system/sysRepairPersonnel/save',
              data
          })
      },
      delete(data){
          return http.json({
              url: `/system/sysRepairPersonnel/delete?id=${data.id}`,
          })
      }
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/groupRepairPerson.js